import { FormSection } from '@/api/rest/connectionApplication/useGetConnectionApplicationSchema';
import { Field } from '@payaca/ambrosia';

import { sentenceCase } from '@payaca/utilities/stringUtilities';
import { get as _get } from 'lodash-es';
import { FC } from 'react';
import FieldSet from './FieldSet';
import FieldSetArrayInnerCard from './FieldSetArrayInnerCard';
import FieldSetArrayOuterCard from './FieldSetArrayOuterCard';
import {
  getDeviceClassSchemaForDeviceType,
  getSchemaDataForDevice,
} from './utils/devices';

export interface IProps {
  schemaSection: FormSection;
  definitions: Record<string, any>;
  fieldKey: string;
  formData: any;
}

const DevicesFieldArrayReadOnly: FC<IProps> = (props) => {
  const { schemaSection, definitions, fieldKey, formData } = props;

  const devices = formData[fieldKey] as any[];

  return (
    <FieldSetArrayOuterCard>
      {devices.map((device, index) => {
        const deviceType = device.deviceType;

        if (!deviceType) {
          // Should not get here!
          return null;
        }

        const item = getDeviceClassSchemaForDeviceType(
          schemaSection,
          deviceType
        );

        const schemaData = getSchemaDataForDevice(
          schemaSection,
          definitions,
          deviceType
        );

        return (
          <FieldSetArrayInnerCard key={index}>
            <Field.Legacy>
              <Field.Label>
                {sentenceCase(item?.properties?.deviceType?.title || '')}
              </Field.Label>

              <p>{_get(formData, `${fieldKey}.${index}.deviceType`)}</p>
            </Field.Legacy>

            {schemaData && (
              <FieldSet
                namespace={`${fieldKey}.${index}`}
                formSection={schemaData}
                definitions={definitions}
                readonly
                formData={formData}
              />
            )}
          </FieldSetArrayInnerCard>
        );
      })}
    </FieldSetArrayOuterCard>
  );
};

export default DevicesFieldArrayReadOnly;
